import type { EmailFormRecipient } from './types';

// A recipient typed as a bare address (no CRM user behind it) carries this
// prefix as its id, so the rest of the composer can tell it from a user uuid
// without a lookup: never fed to `getUUID`, never sent as a `userId`. Kept
// free of React and DOM imports so the reply rule stays unit-testable.
const FREE_RECIPIENT_PREFIX = 'email:';

export const isFreeRecipient = (recipient: { id: string }): boolean =>
  recipient.id.startsWith(FREE_RECIPIENT_PREFIX);

export const freeRecipient = (
  email: string,
  name?: string | null,
): EmailFormRecipient => ({
  id: FREE_RECIPIENT_PREFIX + email.trim().toLowerCase(),
  email: email.trim(),
  name: name ?? undefined,
});
